import React, { useState } from "react";
import { Container, Row, Col, Card, CardBody, Modal, Label, Button, Input, FormFeedback } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import moment from 'moment';
import Snackbars from "../../Utils/Snackbars";
import { checkCSVFileValidation } from "../../Utils/Common";
import useRequests from '../../Utils/useRequests';


const Dividends = props => {
  //meta title
  document.title = "Dividends";
  const { getRequest, postRequest, postRequestByFormData } = useRequests();

  
  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};


  const [StandardModal1, setStandardModal1] = React.useState(false);
  const togStandardModal1 = async () => {
    setAlertData((AlertData) => ({
      ...AlertData,
      variant: 'error',
      message: 'This feature is currently under construction',
    }));
    resetAlertData();
    // setStandardModal1(true);
  }

  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      record_date: '',
      payment_date: '',
      per_token_dividend_amount: '',
    },
    validationSchema: Yup.object({
      record_date: Yup.string()
      .required('Record Date is required'),
      payment_date: Yup.string()
      .required('Payment Date is required'),
      per_token_dividend_amount: Yup.string()
        .matches(
          /^[#0-9]+$/,
          'Please enter a valid dividend amount!'
        )
        .required('Dividend Amount is required'),
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          record_date: values.record_date,
          payment_date: values.payment_date,
          per_token_dividend_amount: values.per_token_dividend_amount
        });
        const res = await postRequest('add-dividend-record', jsonpar);
        if (res && res.code === 200) {
            handleLoadGetTransactionData();

            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'success',
              message: res.message,
            }));
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();
        
        submit1.disabled = false;
        submit1.textContent = 'Submit';

        setStandardModal1(false);
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const [StandardModal2, setStandardModal2] = React.useState(false);
  const togStandardModal2 = async (elementData) => {
    validation2.setValues({
      ...validation2.values,
      dr_id: elementData.dr_id,
      status: elementData.status,
    });
    setStandardModal2(true);
  }

  const [File, setFile] = useState();
  const [FileName, setFileName] = useState('');
  const saveFile = (e) => {
    if((e.target.files).length > 0) {
      setFile(e.target.files[0]);
      setFileName(e.target.files[0].name);

      var validationRes = checkCSVFileValidation(e.target.files[0]);
      if (!validationRes.status) {
        setFile();
        setFileName('');

        setAlertData((AlertData) => ({
          ...AlertData,
          variant: 'error',
          message: validationRes.msg,
        }));
        resetAlertData();

        return false;
      }
    }
  };

  const validation2 = useFormik({
    enableReinitialize: true,

    initialValues: {
      dr_id: '',
      status: '',
    },
    validationSchema: Yup.object({
      status: Yup.string().required('Please select status'),
    }),
    onSubmit: async (values) => {
      try {
        if (FileName === '') {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: 'Please select a CSV!',
          }));
          resetAlertData();

          return false;
        } else if(values.status === 'Approved') {
          let submit1 = document.getElementById('submit2');
          submit1.disabled = true;
          submit1.textContent = 'Processing...';

          const formData = new FormData();
          formData.append("dr_id", values.dr_id);
          formData.append("status", values.status);
          formData.append("file", File);
          formData.append("fileName", FileName);
          const res = await postRequestByFormData('update-dividend-record-status-with-file', formData);
          if (res && res.code === 200) {
            handleLoadGetTransactionData();

            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'success',
              message: res.message,
            }));
          }
          else {
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'error',
              message: res.message,
            }));
          }
          resetAlertData();

          submit1.disabled = false;
          submit1.textContent = 'Submit';

          setStandardModal2(false);
        }
        else {
          let submit1 = document.getElementById('submit2');
          submit1.disabled = true;
          submit1.textContent = 'Processing...';

          const jsonpar = JSON.stringify({
            dr_id : values.dr_id ,
            status: values.status
          });
          const res = await postRequest('update-dividend-record-status', jsonpar);
          if (res && res.code === 200) {
              handleLoadGetTransactionData();

              setAlertData((AlertData) => ({
                ...AlertData,
                variant: 'success',
                message: res.message,
              }));
          }
          else {
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'error',
              message: res.message,
            }));
          }
          resetAlertData();
          
          submit1.disabled = false;
          submit1.textContent = 'Submit';

          setStandardModal2(false);
        }
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const [TransactionTBody, setTransactionTBody] = React.useState('');
  const handleT1Body = async (tempData) => {
    const filePath = tempData.url;
    tempData = tempData.result_data;

    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{moment(element.record_date).format('YYYY-MM-DD')}</td>
        <td>{moment(element.payment_date).format('YYYY-MM-DD')}</td>
        <td><span className={"font-size-14 badge bg-secondary rounded-pill " + (element.status === 'Pending' ? 'badge-soft-warning' : element.status === 'Approved' ? 'badge-soft-success' : 'badge-soft-danger')}>{element.status}</span></td>
        <td className="text-center">
          <div className="centerLink">
            {element.status === 'Pending'?
            <Button className="font-size-14 bg-primary edit-box" onClick={(e)=>togStandardModal2(element)}><i className="bx bx-cog"></i></Button>
            : ''}
            <a rel="noreferrer" href={`${process.env.REACT_APP_API_URL}${filePath}${element.file_name}`} download={element.file_name} className="btn-sm btn btn-primary"><i className="bx bx-download"></i></a>
          </div>
        </td>
      </tr>
    ));

    setTransactionTBody(tempTBody);
  }
  const handleLoadGetTransactionData = async () => {
    const res = await getRequest('get-dividend-record-data');
    if (res && res.code === 200) {
      handleT1Body(res.data);
    }
    else {
      let tempTBody = (<tr>
                        <td colSpan="5" className="text-center">No records found</td>
                      </tr>);

      setTransactionTBody(tempTBody);
    }
  }
  React.useEffect(() => {
    handleLoadGetTransactionData();
  }, []);


  return (
    <React.Fragment>
      {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Eshepay")} breadcrumbItem={props.t("Dividends")} />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="table-rep-plugin">
                    <div className="row">
                      <Col xs={12}>
                        <div className="mb-3">
                          <Button type="button" className="btn btn-primary float-end" onClick={(e) => togStandardModal1()}>Record Dividend</Button>
                        </div>
                      </Col>
                    </div>
                    <div className="table-responsive mb-0 mt-3" data-pattern="priority-columns">
                      <table className="table mb-0" style={{ minWidth: "800px" }}>
                        <thead className="table-light">
                          <tr>
                            <th>#</th>
                            <th>Record Date</th>
                            <th>Payment Date</th>
                            <th>Status</th>
                            <th className="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {TransactionTBody}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Modal className="transation" centered backdrop="static" isOpen={StandardModal2}>
            <div className="modal-header">
              <h5 className="modal-title mt-0">Change Status</h5>
              <button type="button" onClick={(e)=>setStandardModal2(false)} className="close" data-dismiss="modal" aria-label="Close" >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Col md={12}>
                <div className="mb-3">
                  <Label className="form-label">Status : </Label>
                  <select className="form-select" name="status" value={validation2.values.status} onChange={(e) => validation2.setValues({ ...validation2.values, status: e.target.value })}>
                    <option value="Pending">Pending</option>
                    <option value="Approved">Approved</option>
                    <option value="Cancelled">Cancelled</option>
                  </select>
                  {validation2.touched.status && validation2.errors.status ? (
                    <FormFeedback type="invalid">{validation2.errors.status}</FormFeedback>
                  ) : null}
                </div>
              </Col>
              {validation2.values.status === 'Approved'?
                <div>
                  <Col xs={12}>
                    <div className="mb-3">
                      <label className="form-label">Upload Payment CSV Sheet :</label>
                      <Input type="file" className="fileUpload" accept=".csv" onChange={saveFile} />
                    </div>
                  </Col>
                </div>
              :
              <div></div>
              }
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary" 
                id="submit2"
                onClick={(e) => {
                  e.preventDefault();
                  validation2.handleSubmit();
                  return false;
                }}
              >Submit</button>
              <button type="button" className="btn btn-light" data-dismiss="modal" onClick={(e)=>setStandardModal2(false)} aria-label="Close">Close</button>
            </div>
          </Modal>


          <Modal className="transation" centered backdrop="static" isOpen={StandardModal1}>
            <div className="modal-header">
              <h5 className="modal-title mt-0">Record Dividend</h5>
              <button type="button" onClick={(e)=>setStandardModal1(false)} className="close" data-dismiss="modal" aria-label="Close" >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body mb-3">
              <div className="row">
                <Col xs={12}>
                  <div className="mb-3">
                    <label className="form-label">Record Date :</label>
                    <Input type="date"
                      name="record_date"
                      onChange={validation1.handleChange}
                      onBlur={validation1.handleBlur}
                      value={validation1.values.record_date || ""}
                      invalid={
                        validation1.touched.record_date && validation1.errors.record_date ? true : false
                      }
                    />
                    {validation1.touched.record_date && validation1.errors.record_date ? (
                      <FormFeedback type="invalid">{validation1.errors.record_date}</FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <Col xs={12}>
                  <div className="mb-3">
                    <label className="form-label">Payment Date :</label>
                    <Input type="date" 
                      name="payment_date"
                      onChange={validation1.handleChange}
                      onBlur={validation1.handleBlur}
                      value={validation1.values.payment_date || ""}
                      invalid={
                        validation1.touched.payment_date && validation1.errors.payment_date ? true : false
                      }
                    />
                    {validation1.touched.payment_date && validation1.errors.payment_date ? (
                      <FormFeedback type="invalid">{validation1.errors.payment_date}</FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <Col xs={12}>
                  <div className="mb-3">
                    <label className="form-label">Dividend Amount $ ( Per Token Dividend ) :</label>
                    <Input type="text"
                      placeholder="Enter dividend amount"
                      name="per_token_dividend_amount"
                      onChange={validation1.handleChange}
                      onBlur={validation1.handleBlur}
                      value={validation1.values.per_token_dividend_amount || ""}
                      invalid={
                        validation1.touched.per_token_dividend_amount && validation1.errors.per_token_dividend_amount ? true : false
                      }
                    />
                    {validation1.touched.per_token_dividend_amount && validation1.errors.per_token_dividend_amount ? (
                      <FormFeedback type="invalid">{validation1.errors.per_token_dividend_amount}</FormFeedback>
                    ) : null}
                  </div>
                </Col>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary"
                id="submit1"
                onClick={(e) => {
                  e.preventDefault();
                  validation1.handleSubmit();
                  return false;
                }}
              >Submit</button>
              <button type="button" className="btn btn-light" data-dismiss="modal" onClick={(e)=>setStandardModal1(false)} aria-label="Close">Close</button>
            </div>
          </Modal>
        </Container>
      </div>

    </React.Fragment>
  );
};

export default withTranslation()(Dividends);
